import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faBookOpen,
  faChartLine,
  faClock,
  faAward,
} from "@fortawesome/free-solid-svg-icons";

import phonePrice from "../imagesHome/phone_price.png";
import contiPrice from "../imagesHome/conti.png";

import "./ContiBenefits.css";

const benefits = [
  {
    id: "lectii",
    title: "Lectii interactive",
    description:
      "Invata contabilitate pas cu pas, prin explicatii clare si exercitii care te ajuta sa intelegi fiecare notiune.",
    icon: faBookOpen,
  },
  {
    id: "progres",
    title: "Urmareste progresul",
    description:
      "Descopera ce lectii ai finalizat si urmareste-ti evolutia pe parcursul cursurilor.",
    icon: faChartLine,
  },
  {
    id: "ritm",
    title: "Invata in ritmul tau",
    description:
      "Studiaza atunci cand ai timp si revino asupra lectiilor pentru a recapitula informatiile.",
    icon: faClock,
  },
  {
    id: "certificate",
    title: "Certificate de finalizare",
    description:
      "Obtine certificate ContaLearn dupa finalizarea cursurilor eligibile, conform conditiilor acestora.",
    icon: faAward,
  },
];

export default function ContiBenefits() {
  const [activeBenefit, setActiveBenefit] = useState(0);

  const selectedBenefit = benefits[activeBenefit];

  useEffect(() => {
    const media = window.matchMedia("(max-width: 600px)");

    if (!media.matches) {
      return;
    }

    const interval = window.setInterval(() => {
      setActiveBenefit((current) =>
        (current + 1) % benefits.length
      );
    }, 4500);

    return () => {
      window.clearInterval(interval);
    };
  }, []);

  return (
    <section
      className="conti-benefits-section"
      aria-labelledby="conti-benefits-title"
    >
      <div className="conti-benefits-header">
        <h2 id="conti-benefits-title">
          Invata contabilitate alaturi de Conti
        </h2>
      </div>

      <div className="conti-benefits-layout">

        {/* DESKTOP - MENIU STANGA */}

        <div
          className="conti-benefits-menu"
          aria-label="Beneficiile ContaLearn"
        >
          {benefits.map((benefit, index) => (
            <button
              key={benefit.id}
              type="button"
              className={
                `conti-benefits-item${
                  activeBenefit === index
                    ? " active"
                    : ""
                }`
              }
              aria-pressed={
                activeBenefit === index
              }
              onClick={() =>
                setActiveBenefit(index)
              }
            >
              <span
                className="conti-benefits-item-icon"
                aria-hidden="true"
              >
                <FontAwesomeIcon
                  icon={benefit.icon}
                />
              </span>

              <span>{benefit.title}</span>
            </button>
          ))}
        </div>

        {/* TELEFON + CONTI */}

        <div className="conti-benefits-visual">
          <img
            src={phonePrice}
            alt="Aplicatia ContaLearn pe telefon"
            className="conti-benefits-phone"
          />

          <img
            src={contiPrice}
            alt="Conti, mascota ContaLearn"
            className="conti-benefits-mascot"
          />
        </div>

        {/* CARD BENEFICIU */}

        <div
          className="conti-benefits-description"
          aria-live="polite"
          aria-atomic="true"
        >
          <div className="conti-benefits-mobile-icon">
            <FontAwesomeIcon
              icon={selectedBenefit.icon}
            />
          </div>

          <h3>
            {selectedBenefit.title}
          </h3>

          <p>
            {selectedBenefit.description}
          </p>
        </div>

        {/* PUNCTE - DOAR MOBILE */}

        <div
          className="conti-benefits-dots"
          role="group"
          aria-label="Schimba beneficiul"
        >
          {benefits.map((benefit, index) => (
            <button
              key={benefit.id}
              type="button"
              className={
                `conti-benefits-dot${
                  activeBenefit === index
                    ? " active"
                    : ""
                }`
              }
              aria-label={
                `Afiseaza ${benefit.title}`
              }
              aria-pressed={
                activeBenefit === index
              }
              onClick={() =>
                setActiveBenefit(index)
              }
            />
          ))}
        </div>

      </div>
    </section>
  );
}